var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPsychologicalSafety(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0797 5.08979V10.8798C11.0797 11.8798 10.2697 12.6898 9.26973 12.6898C8.26973 12.6898 7.45973 11.8798 7.45973 10.8798C7.45973 10.6398 7.50973 10.3898 7.59973 10.1698C6.78973 9.77979 6.21973 8.94979 6.21973 7.98979C6.21973 7.02979 6.78973 6.18979 7.59973 5.79979C7.50973 5.57979 7.45973 5.34979 7.45973 5.08979C7.45973 4.08979 8.26973 3.27979 9.26973 3.27979C10.2697 3.27979 11.0797 4.08979 11.0797 5.08979Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27949 6.86982C8.28949 6.86982 7.47949 6.06982 7.47949 5.06982",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41953 20.7199V19.6799L3.27953 15.5399C2.78953 15.0499 2.51953 14.3899 2.51953 13.6999V9.98986C2.51953 9.49986 2.90953 9.10986 3.39953 9.10986C3.88953 9.10986 4.27953 9.49986 4.27953 9.98986V13.0199L5.42953 14.1699",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33953 17.1398L5.53953 15.3398C5.17953 14.9798 5.17953 14.3898 5.53953 14.0298C5.89953 13.6698 6.48953 13.6698 6.84953 14.0298L8.64953 15.8298",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64941 15.8301L9.49941 16.6801C9.98941 17.1701 10.2694 17.8401 10.2694 18.5401V20.7201",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9199 5.08979V10.8798C12.9199 11.8798 13.7299 12.6898 14.7299 12.6898C15.7299 12.6898 16.5399 11.8798 16.5399 10.8798C16.5399 10.6398 16.4899 10.3898 16.3999 10.1698C17.2099 9.77979 17.7799 8.94979 17.7799 7.98979C17.7799 7.02979 17.2099 6.18979 16.3999 5.79979C16.4899 5.57979 16.5399 5.34979 16.5399 5.08979C16.5399 4.08979 15.7299 3.27979 14.7299 3.27979C13.7299 3.27979 12.9199 4.08979 12.9199 5.08979Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7197 6.86982C15.7097 6.86982 16.5197 6.06982 16.5197 5.06982",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5801 20.7199V19.6799L20.7201 15.5399C21.2101 15.0499 21.4801 14.3899 21.4801 13.6999V9.98986C21.4801 9.49986 21.0901 9.10986 20.6001 9.10986C20.1101 9.10986 19.7201 9.49986 19.7201 9.98986V13.0199L18.5701 14.1699",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6606 17.1398L18.4606 15.3398C18.8206 14.9798 18.8206 14.3898 18.4606 14.0298C18.1006 13.6698 17.5106 13.6698 17.1506 14.0298L15.3506 15.8298",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3505 15.8301L14.5005 16.6801C14.0105 17.1701 13.7305 17.8401 13.7305 18.5401V20.7201",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsychologicalSafety);
export default __webpack_public_path__ + "static/media/Psychological Safety.4c42da9c0cb56858e5d5956a9c7c5b1a.svg";
export { ForwardRef as ReactComponent };